document.addEventListener("DOMContentLoaded", async function () {
    if (typeof window.Shopify !== "undefined" && window.Shopify.routes) {
        const shopdomain = Shopify.shop || window.location.hostname;
        const locale = window.Shopify.locale;

        function setInventoryData(key, value) {
            const setdata = (JSON.stringify(value)).replaceAll(';', '%3B');
            const expiryDate = new Date();
            expiryDate.setMinutes(expiryDate.getMinutes() + 60);
            document.cookie = `${key}=${setdata}; expires=${expiryDate.toUTCString()}; path=/`;
        }

        function getInventoryData(key) {

            const cookies = document.cookie.split("; ");
            for (let cookie of cookies) {
                const [ckey, value] = cookie.split("=");
                if(ckey === key) return value;
            }
            return null;
        }

        const getloc_inventory_stock = async () => {
            const cached = getInventoryData("allInvntoryData");
            // console.log('Cached data:', cached);
            if (cached) {
                try {
                    const recivieddata = JSON.parse(decodeURIComponent(cached));
                    return recivieddata;
                } catch (e) {
                    console.error('Error parsing cached data:', e);
                    console.error('Invalid JSON:', cached); // Log the problematic JSON
                    return null; // Return null or handle the error gracefully
                }
            }

            try {
                var variant_id = 0;
                var fromgeoblock = true;
                var product_id = 0;
                const url = `https://multilocation.techspawn.net/api/get-loc-inventory-stock?shopdomain=${encodeURIComponent(shopdomain)}&variant_id=${encodeURIComponent(variant_id)}&locale=${encodeURIComponent(locale)}&fromgeoblock=${encodeURIComponent(fromgeoblock)}&product_id=${encodeURIComponent(product_id)}`;
                const result = await fetch(url, {
                    method: 'GET',
                });
                if (!result.ok) {
                    throw new Error(`HTTP error! Status: ${result.status}`);
                }
                const data = await result.json();
                // console.log('Fetched data:', data);
                setInventoryData("allInvntoryData", data);
                return data;
            } catch (error) {
                console.error('Error:', error);
            }
        }

        // Add a function to observe DOM changes and detect when an element is added
        function waitForElement(selector, callback) {
            // Check if element already exists
            const element = document.querySelector(selector);
            if (element) {
                callback(element);
                return;
            }

            // If not, set up a mutation observer to watch for it
            const observer = new MutationObserver((mutations) => {
                const element = document.querySelector(selector);
                if (element) {
                    observer.disconnect();
                    callback(element);
                }
            });

            // Start observing the document with the configured parameters
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }

        function haversineDistance(lat1, lon1, lat2, lon2, distanceIN) {
            const toRadians = (degrees) => degrees * (Math.PI / 180);
            const R = 6371;
            const dLat = toRadians(lat2 - lat1);
            const dLon = toRadians(lon2 - lon1);
            const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            let distance = R * c;
            if (distanceIN === 'false') {
                distance *= 0.621371;
            }
            return distance;
        }

        var enabledSmartCollectionFilter = false;
        const display_location_stock = async (variant_id, baseUrl) => {
            const allInvntoryData = await getloc_inventory_stock();
            const invntorydata = allInvntoryData?.settings;
            const locationPopup = invntorydata?.locationPopup;
            const locationPopupstyle = invntorydata?.locationPopupstyle;
            // const locationSelectionType = invntorydata?.locationSelectionType;
            const locationPopupHeader = invntorydata?.locationPopupHeader;
            const locationPopupDescription = invntorydata?.locationPopupDescription ?? '';
            // const locationarr = allInvntoryData?.settings?.locations_arr;
            var locationarr = allInvntoryData.settings.locations_arr
            const locationSelectionType = allInvntoryData.settings.locationSelectionType;
            const headerBlock = allInvntoryData?.settings?.headerBlock;
            const headerBlockstyle = allInvntoryData?.settings?.headerBlockstyle;
            const enableGeolocationSearch = invntorydata?.locationFilterSetting?.enableGeolocationSearch ?? 'false';
            const google_map_api_key = invntorydata?.locationFilterSetting?.google_api_key ?? '';
            const distanceIN = invntorydata?.distanceIN;
            const showSettingsHeaderres = invntorydata?.showSettingsHeader ?? '[]';
            let showSettingsHeader;
            try {
                showSettingsHeader = JSON.parse(showSettingsHeaderres);
            } catch (error) {
                showSettingsHeader = []; // Fallback to an empty array
            }
            const headerSettingsPriority = JSON.parse(invntorydata?.headerSettingsPriority);

            enabledSmartCollectionFilter = allInvntoryData?.settings?.enabledSmartCollectionFilter;

            window.locationPopupData = {
                locationPopup,
                locationPopupstyle,
                locationSelectionType,
                locationPopupHeader,
                locationPopupDescription,
                locationarr
            };

            // window.locationStockData = {
            //     locationarr
            // };
            // const enableGeolocationSearch = allInvntoryData?.settings?.locationFilterSetting?.enableGeolocationSearch ?? 'false';

            const locationNamesDropDown = document.getElementById("locationNamesDropDown");
            const conatinerforall = document.createElement("div");
            const locationNamesDropDownselect = document.createElement("select");
            if (locationNamesDropDown && headerBlock === 'true') {
                locationNamesDropDown.innerHTML = "";

                const locations_arr = allInvntoryData.settings.locations_arr;

                if (headerBlockstyle === 'dropdown') {
                    locationNamesDropDownselect.id = "locationNamesDropDownselect";
                    locationNamesDropDownselect.name = "selected_location";
                    locationNamesDropDownselect.classList.add("location-dropdown");
                    const option = document.createElement("option");
                    option.value = "";
                    option.textContent = "Select a location";
                    locationNamesDropDownselect.appendChild(option);
                    for (const location of locations_arr) {
                        const option = document.createElement("option");
                        option.value = location.node.id.split('/').pop();
                        option.textContent = location.node.name;
                        locationNamesDropDownselect.appendChild(option);
                    }
                    locationNamesDropDown.appendChild(locationNamesDropDownselect);

                    // Sync dropdown selection with radio button selection
                    locationNamesDropDownselect.addEventListener('change', function () {
                        const selectedLocationId = locationNamesDropDownselect.value;

                        // Save the selected location to LocalStorage
                        localStorage.setItem("selected_location", selectedLocationId);

                        // Find the radio button that matches the selected location
                        const matchingRadioButton = document.querySelector(`input[name="selected_location"][value="${selectedLocationId}"]`);

                        if (matchingRadioButton) {
                            matchingRadioButton.checked = true;
                            if (locationSelectionType === 'colorinversion') {
                                const locationCard = matchingRadioButton.closest(".location-card-listview");
                                if (locationCard) {
                                    // First remove any existing styles from all cards
                                    const allLocationCards = document.querySelectorAll(".location-card-listview");
                                    allLocationCards.forEach(card => {
                                        card.style.removeProperty('background-color');
                                        card.style.removeProperty('color');
                                    });
                                    // Then set the styles for the selected card
                                    locationCard.style.backgroundColor = "rgb(var(--color-foreground))";
                                    locationCard.style.color = "rgb(var(--color-background))";
                                }
                            }
                        }
                        updateCollectionInventory();
                    });
                }

                if (headerBlockstyle === 'popup') {
                    const locationshowonheader = document.createElement("div");
                    locationshowonheader.classList.add("location-popup-header");
                    locationshowonheader.id = "location-popup-header-id";
                    const savelocationid = localStorage.getItem("selected_location");
                    if (savelocationid == null || savelocationid == undefined || savelocationid == 'undefined' || savelocationid == '') {
                        locationshowonheader.textContent = "Select a location";
                    } else {
                        for (const location of locations_arr) {
                            if (location.node.id.split('/').pop() == savelocationid) {
                                locationshowonheader.textContent = location.node.name;
                            }
                        }
                    }
                    locationNamesDropDown.appendChild(locationshowonheader);
                    locationshowonheader.addEventListener("click", function () {
                        document.dispatchEvent(new CustomEvent("openLocationPopup"));
                    });
                }

                if (headerBlockstyle === 'drawer') {

                    const locationshowonheader = document.createElement("div");
                    locationshowonheader.classList.add("location-popup-header");
                    locationshowonheader.id = "location-popup-header-id";
                    const savelocationid = localStorage.getItem("selected_location");
                    if (savelocationid == null || savelocationid == undefined || savelocationid == 'undefined' || savelocationid == '') {
                        locationshowonheader.textContent = "Select a location";
                    } else {
                        for (const location of locations_arr) {
                            if (location.node.id.split('/').pop() == savelocationid) {
                                locationshowonheader.textContent = location.node.name;
                            }
                        }
                    }
                    locationNamesDropDown.appendChild(locationshowonheader);
                    locationshowonheader.addEventListener("click", function () {
                        const savelocationid = localStorage.getItem("selected_location");
                        const drawerOverlay = document.createElement("div");
                        drawerOverlay.id = "inventoryDrawerOverlay";
                        drawerOverlay.classList.add("multiloca-inventory-drawer-overlay");

                        const drawerContent = document.createElement("div");
                        drawerContent.id = "inventoryDrawerContent";
                        drawerContent.classList.add("multiloca-inventory-drawer-content");
                        drawerContent.style.animation = ".4s ease-out slideup-location-drawer";

                        const drawerHeader = document.createElement("div");
                        drawerHeader.id = "inventoryDrawerHeader";
                        drawerHeader.classList.add("custom_drawer__header");

                        const drawerTitle = document.createElement("h2");
                        drawerTitle.id = "inventoryDrawerTitle";
                        drawerTitle.classList.add("multiloca-inventory-drawer-title");
                        drawerTitle.textContent = "Select a Location";
                        drawerHeader.appendChild(drawerTitle);
                        drawerContent.appendChild(drawerHeader);

                        const closeButton = document.createElement("button");
                        closeButton.id = "closeDrawerButton";
                        closeButton.classList.add("multiloca-close-drawer-button");
                        closeButton.textContent = "X";
                        closeButton.addEventListener("click", function () {
                            drawerContent.style.animation = ".2s ease-out slidedown-location-drawer";
                            setTimeout(() => {
                                document.body.removeChild(drawerOverlay);
                            }, 200);
                        });
                        drawerContent.appendChild(closeButton);

                        const locationsContainer = document.createElement("div");
                        locationsContainer.id = "drawerLocationsContainer";
                        locationsContainer.style.backgroundColor = "#f5f5f5";
                        drawerContent.appendChild(locationsContainer);


                        //geolocation code
                        const geolocationSearch = document.createElement("div");
                        const geolocationSearchInput = document.createElement("input");
                        const usemylocation = document.createElement("a");
                        const searchIcon = document.createElement("span");
                        const predictionlocationNames = [];
                        if (enableGeolocationSearch == 'true' && google_map_api_key != '') {
                            const googlePlacesScript = document.createElement('script');
                            googlePlacesScript.src = `https://maps.googleapis.com/maps/api/js?key=${google_map_api_key}&libraries=places`;
                            document.head.appendChild(googlePlacesScript);
                            geolocationSearch.classList.add("geolocation-search");
                            geolocationSearchInput.type = "text";
                            geolocationSearchInput.placeholder = "Enter address, zip code or city";
                            geolocationSearchInput.classList.add("geolocation-search-input");
                            searchIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 96 960 960" width="20"><path d="M796 876 590 670q-34 29-72.5 44t-82.5 15q-108 0-183.5-75.5T176 470q0-108 75.5-183.5T435 211q108 0 183.5 75.5T694 470q0 45-14 85t-44 75l207 207q9 9 9 21t-9 21l-29 29q-9 9-21 9t-21-9ZM436 674q75 0 127.5-52.5T616 470q0-75-52.5-127.5T436 290q-75 0-127.5 52.5T256 470q0 75 52.5 127.5T436 674Z"/></svg>`;
                            searchIcon.classList.add("search-icon");
                            usemylocation.innerHTML = `
                                    <svg viewBox="0 0 24 24" focusable="false" width="24" height="24" aria-hidden="true" class="hnf-svg-icon hnf-btn__icon"><path d="M12 15c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M18.9205 13H21v-2h-2.0795A6.9929 6.9929 0 0 0 13 5.08V3h-2v2.08A6.9928 6.9928 0 0 0 5.08 11H3v2h2.08A6.9924 6.9924 0 0 0 11 18.9205V21h2v-2.0795A6.9927 6.9927 0 0 0 18.9205 13zm-2.7632-3.7779A4.9993 4.9993 0 0 1 17 12a5.006 5.006 0 0 1-1.4661 3.5339A5.006 5.006 0 0 1 12 17a5 5 0 1 1 4.1573-7.7779z"></path></svg>`;
                            usemylocation.classList.add("use-my-location");
                            usemylocation.href = "#";
                            usemylocation.addEventListener("click", async (e) => {
                                e.preventDefault();
                                try {
                                    const position = await new Promise((resolve, reject) => {
                                        navigator.geolocation.getCurrentPosition(resolve, reject);
                                    });
                                    cust_lat = position.coords.latitude;
                                    cust_lng = position.coords.longitude;
                                    geolocationSearchInput.value = "";
                                    const detailsUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${cust_lat},${cust_lng}&key=${google_map_api_key}`;
                                    fetch(detailsUrl)
                                        .then(response => response.json())
                                        .then(details => {
                                            if (details.results && details.results.length > 0) {
                                                const components = details.results[0].address_components;
                                                const address = components.find(component => component.types.includes("street_number"));
                                                const city = components.find(component => component.types.includes("locality"));
                                                const state = components.find(component => component.types.includes("administrative_area_level_1"));
                                                const zip = components.find(component => component.types.includes("postal_code"));
                                                const country = components.find(component => component.types.includes("country"));
                                                geolocationSearchInput.value = `${address ? address.long_name : ''} ${city ? city.long_name : ''} ${state ? state.long_name : ''} ${zip ? zip.long_name : ''} ${country ? country.long_name : ''}`;

                                                locations_arr.forEach((loc) => {
                                                    var corrdiloc = loc.node.address.latitude + ',' + loc.node.address.longitude;
                                                    let locCoords = corrdiloc ? corrdiloc.split(',') : [];
                                                    locCoords[0] = parseFloat(locCoords[0]);
                                                    locCoords[1] = parseFloat(locCoords[1]);
                                                    loc.distance = haversineDistance(cust_lat, cust_lng, locCoords[0], locCoords[1], distanceIN);
                                                    if (Number.isNaN(loc.distance)) {
                                                        loc.distance = '-';
                                                    }
                                                });
                                                locations_arr.sort((a, b) => {
                                                    if (a.distance === '-' && b.distance === '-') return 0;
                                                    if (a.distance === '-') return 1;
                                                    if (b.distance === '-') return -1;
                                                    return a.distance - b.distance;
                                                });
                                                showfilrterdlocations(locations_arr);
                                            }
                                        })
                                        .catch(error => {
                                            console.error("Error fetching place details:", error);
                                        });
                                } catch (error) {
                                    console.error(error);
                                }
                            });
                            console.log(locations_arr);
                            geolocationSearch.appendChild(searchIcon);
                            geolocationSearch.appendChild(geolocationSearchInput);
                            geolocationSearch.appendChild(usemylocation);

                            locationsContainer.appendChild(geolocationSearch);
                            // locationsContainer.appendChild(usemylocation);
                            const a = document.createElement("div");
                            a.classList.add("autocomplete-items");
                            geolocationSearch.appendChild(a);

                            let addalready = false;
                            geolocationSearchInput.addEventListener('input', function (event) {
                                const searchValue = event.target.value;

                                if (addalready == false) {
                                    addalready = true;
                                    usemylocation.innerHTML = searchIcon.innerHTML;
                                  }
                                  searchIcon.innerHTML = "";
                 
                                  if (searchValue === "") {
                                    addalready = false;
                                    searchIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 96 960 960" width="20"><path d="M796 876 590 670q-34 29-72.5 44t-82.5 15q-108 0-183.5-75.5T176 470q0-108 75.5-183.5T435 211q108 0 183.5 75.5T694 470q0 45-14 85t-44 75l207 207q9 9 9 21t-9 21l-29 29q-9 9-21 9t-21-9ZM436 674q75 0 127.5-52.5T616 470q0-75-52.5-127.5T436 290q-75 0-127.5 52.5T256 470q0 75 52.5 127.5T436 674Z"/></svg>`;
                                    usemylocation.innerHTML = `<svg viewBox="0 0 24 24" focusable="false" width="24" height="24" aria-hidden="true" class="hnf-svg-icon hnf-btn__icon"><path d="M12 15c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M18.9205 13H21v-2h-2.0795A6.9929 6.9929 0 0 0 13 5.08V3h-2v2.08A6.9928 6.9928 0 0 0 5.08 11H3v2h2.08A6.9924 6.9924 0 0 0 11 18.9205V21h2v-2.0795A6.9927 6.9927 0 0 0 18.9205 13zm-2.7632-3.7779A4.9993 4.9993 0 0 1 17 12a5.006 5.006 0 0 1-1.4661 3.5339A5.006 5.006 0 0 1 12 17a5 5 0 1 1 4.1573-7.7779z"></path></svg>`;
                                    a.innerHTML = "";
                                    return;
                                  }

                                const autocompleteService = new google.maps.places.AutocompleteService();

                                autocompleteService.getPlacePredictions(
                                    { input: searchValue },
                                    (predictions, status) => {
                                        if (status === google.maps.places.PlacesServiceStatus.OK) {
                                            predictions.forEach(prediction => {
                                                predictionlocationNames.push({
                                                    description: prediction.description,
                                                    placeId: prediction.place_id,
                                                });
                                            });
                                        } else {
                                            console.error('Error fetching predictions:', status);
                                        }
                                    }
                                );

                                a.innerHTML = "";
                                var loc_lat;
                                var loc_lng;
                                const filteredNames = predictionlocationNames.filter(n =>
                                    n.description.toLowerCase().includes(searchValue.toLowerCase())
                                );
                                filteredNames.slice(0, 5).forEach(name => {
                                    let uniqueId = `placeId-${Math.random().toString(36).substr(2, 9)}`;
                                    const b = document.createElement("div");
                                    b.innerHTML = "<strong>" + name.description.substr(0, searchValue.length) + "</strong>";
                                    b.innerHTML += name.description.substr(searchValue.length);
                                    b.innerHTML += "<input type='hidden' value='" + name.description + "'>";
                                    b.innerHTML += `<input type='hidden' value='${name.placeId}' id='${uniqueId}'>`;
                                    b.addEventListener("click", function (e) {
                                        const selectedPlaceId = document.getElementById(uniqueId).value;
                                        geolocationSearchInput.value = this.getElementsByTagName("input")[0].value;
                                        const detailsUrl = `https://maps.googleapis.com/maps/api/place/details/json?place_id=${selectedPlaceId}&key=${google_map_api_key}`;
                                        fetch(detailsUrl)
                                            .then(response => response.json())
                                            .then(details => {
                                                if (details.result.geometry) {
                                                    loc_lat = details.result.geometry.location.lat;
                                                    loc_lng = details.result.geometry.location.lng;

                                                    locations_arr.forEach((loc) => {
                                                        var corrdiloc = loc.node.address.latitude + ',' + loc.node.address.longitude;
                                                        let locCoords = corrdiloc ? corrdiloc.split(',') : [];
                                                        locCoords[0] = parseFloat(locCoords[0]);
                                                        locCoords[1] = parseFloat(locCoords[1]);
                                                        loc.distance = haversineDistance(loc_lat, loc_lng, locCoords[0], locCoords[1]);
                                                        if (Number.isNaN(loc.distance)) {
                                                            loc.distance = '-';
                                                        }
                                                    });
                                                    locations_arr.sort((a, b) => {
                                                        if (a.distance === '-' && b.distance === '-') return 0;
                                                        if (a.distance === '-') return 1;
                                                        if (b.distance === '-') return -1;
                                                        return a.distance - b.distance;
                                                    });
                                                    showfilrterdlocations(locations_arr);
                                                } else {
                                                    console.error("No geometry data available for this place.");
                                                }
                                            })
                                            .catch(error => {
                                                console.error("Error fetching place details:", error);
                                            });
                                        a.innerHTML = "";
                                    });
                                    a.appendChild(b);
                                });

                            });
                        }

                        showfilrterdlocations(locations_arr);
                        function showfilrterdlocations(locations_arr) {
                            //clear all location card from locationsContainer
                            const locationcontainer = document.querySelectorAll(".locationCardDrawerView");
                            if(locationcontainer){
                                locationcontainer.forEach((loc) => {
                                    loc.remove();
                                });
                            }
                            for (const location of locations_arr) {
                                const locationCard = document.createElement("div");
                                locationCard.classList.add("locationCardDrawerView");
                                if (location.node.id.split('/').pop() == savelocationid) {
                                    locationCard.classList.add("location-card-drawer-list-view-selected");
                                } else {
                                    locationCard.classList.add("location-card-drawer-list-view");
                                }
                                locationCard.setAttribute("data-location-id", location.node.id.split('/').pop());

                                const locationNameshow = document.createElement("div");
                                locationNameshow.classList.add("location-card-drawer-list-view-name");
                                locationNameshow.textContent = location.node.name;
                                locationCard.appendChild(locationNameshow);

                                const locationAddress = document.createElement("div");
                                locationAddress.classList.add("location-card-drawer-list-view-address");
                                for (const address of location.node.address.formatted) {
                                    locationAddress.innerHTML += address + "<br />";
                                }

                                const locationPhone = document.createElement("div");
                                locationPhone.classList.add("location-card-drawer-list-view-phone");
                                locationPhone.textContent = location.node.address.phone;
                                // locationCard.appendChild(locationPhone);

                                const locationNote = document.createElement("div");
                                locationNote.classList.add("location-card-drawer-list-view-note");
                                locationNote.textContent = location.node.location_notes;
                                // locationCard.appendChild(locationNote);

                                const locationDirection = document.createElement("div");
                                locationDirection.classList.add("location-card-drawer-list-view-direction");
                                locationDirection.innerHTML = `<a href="https://www.google.com/maps/dir/?api=1&destination=${location.node.address.latitude},${location.node.address.longitude}" target="_blank">Get Directions</a>`;
                                // locationCard.appendChild(locationDirection);

                                const elementsMap = {
                                    "Show location address" : locationAddress,
                                    "Show location phone number" : locationPhone,
                                    "Show location notes" : locationNote,
                                    "Show location directions" : locationDirection
                                };

                                headerSettingsPriority.forEach((key) => {
                                    if (elementsMap[key]) {
                                        if (key === 'Show location address') {
                                            if(showSettingsHeader?.address == true || showSettingsHeader?.address == 'true'){
                                                locationCard.appendChild(locationAddress);
                                            }
                                        }
                                        if (key === 'Show location phone number') {
                                            if(showSettingsHeader?.phone == true || showSettingsHeader?.phone == 'true'){
                                                locationCard.appendChild(locationPhone);
                                            }
                                        }
                                        if (key === 'Show location notes') {
                                            if(showSettingsHeader?.notes == true || showSettingsHeader?.notes == 'true'){
                                                locationCard.appendChild(locationNote);
                                            }
                                        }
                                        if (key === 'Show location directions') {
                                            if(showSettingsHeader?.directions == true || showSettingsHeader?.directions == 'true'){
                                                locationCard.appendChild(locationDirection);
                                            }
                                        }
                                    }
                                })

                                locationsContainer.appendChild(locationCard);

                                locationCard.addEventListener("click", function () {
                                    const selectedLocationId = locationCard.getAttribute("data-location-id");
                                    localStorage.setItem("selected_location", selectedLocationId);
                                    setTimeout(() => {
                                        // Remove the selected class from all location cards
                                        const allLocationCards = document.querySelectorAll(".location-card-drawer-list-view-selected");
                                        console.log(allLocationCards);
                                        allLocationCards.forEach(card => {
                                            console.log(card);
                                            card.classList.remove("location-card-drawer-list-view-selected");
                                            card.classList.add("location-card-drawer-list-view");
                                        });
                                        console.log(locationCard);
                                        // Add the selected class to the clicked card
                                        locationCard.classList.remove("location-card-drawer-list-view");
                                        locationCard.classList.add("location-card-drawer-list-view-selected");
                                        locationCard.dataset.selected = true;

                                        // Update the header location name
                                        locationshowonheader.textContent = location.node.name;

                                        // Close the drawer
                                        document.body.removeChild(drawerOverlay);
                                    }, 50); // Delay of 50ms
                                    // Trigger change event for the dropdown
                                    updateCollectionInventory();

                                    if (enabledSmartCollectionFilter === true || enabledSmartCollectionFilter === 'true') {
                                        if (window.location.pathname.includes('/collections/')) {
                                            updateFilterURL(location.node.name);
                                            applyShopifyFilter();
                                        }
                                    }

                                    // const event = new Event('change', { bubbles: true });
                                    // locationNamesDropDownselect.dispatchEvent(event);

                                    // Call showlocations function if it's accessible
                                    if (window.multiLocationShowLocations) {
                                        window.multiLocationShowLocations(selectedLocationId);
                                    }
                                });
                            }
                        }



                        // Append the drawer content to the overlay
                        drawerOverlay.appendChild(drawerContent);

                        // Append the overlay to the body
                        document.body.appendChild(drawerOverlay);
                    });

                }

                // After appending the dropdown to the DOM

                updateCollectionInventory();
                locationNamesDropDownselect.addEventListener('change', function () {
                    const selectedLocationId = locationNamesDropDownselect.value;
                    localStorage.setItem("selected_location", selectedLocationId);

                    // Get all product pages' radio buttons that match the selected location
                    const matchingRadioButtons = document.querySelectorAll(`input[name="selected_location"][value="${selectedLocationId}"]`);
                    matchingRadioButtons.forEach(radio => {
                        radio.checked = true;

                        // Dispatch a custom click event to ensure any associated event handlers run
                        const clickEvent = new Event('change', { bubbles: true });
                        radio.dispatchEvent(clickEvent);

                        // Apply styling if needed
                        if (locationSelectionType === 'colorinversion') {
                            const locationCard = radio.closest(".location-card-listview");
                            if (locationCard) {
                                // Reset all cards
                                const allLocationCards = document.querySelectorAll(".location-card-listview");
                                allLocationCards.forEach(card => {
                                    card.style.removeProperty('background-color');
                                    card.style.removeProperty('color');
                                });
                                // Style the selected card
                                locationCard.style.backgroundColor = "rgb(var(--color-foreground))";
                                locationCard.style.color = "rgb(var(--color-background))";
                            }
                        }
                    });

                    // Call showlocations function if it's accessible
                    if (window.multiLocationShowLocations) {
                        window.multiLocationShowLocations(selectedLocationId);
                    }

                    console.log("Location changed to:", selectedLocationId);
                });
            } else {
                locationNamesDropDown.innerHTML = "";
            }

            const savedLocationId = localStorage.getItem("selected_location");
            if (savedLocationId) {
                locationNamesDropDownselect.value = savedLocationId;
            }
        }

        // Wait for the header location dropdown to be added to the DOM
        waitForElement("#locationNamesDropDownselect", (headerLocationDropdown) => {
            headerLocationDropdown.addEventListener("change", function () {
                const selectedLocationId = headerLocationDropdown.value;
                localStorage.setItem("selected_location", selectedLocationId);
                console.log("Header location changed to:", selectedLocationId);

                // Dispatch a custom event that other scripts can listen for
                const event = new CustomEvent('locationChanged', {
                    detail: { locationId: selectedLocationId }
                });
                document.dispatchEvent(event);
                updateCollectionInventory();
            });
        });

        display_location_stock();

        // Header block base locations collection filter
        function attachDropdownListener(locationDropdown) {
            locationDropdown.addEventListener('change', function () {
                let selectedOption = locationDropdown.options[locationDropdown.selectedIndex];
                let selectedLocation = selectedOption ? selectedOption.textContent.trim() : null;
                if (selectedLocation) {
                    let filterCheckboxes = document.querySelectorAll('input[type="checkbox"]');
                    let locationMatched = false;
                    filterCheckboxes.forEach(checkbox => {
                        let label = checkbox.closest('label');
                        let labelText = label ? label.textContent.trim() : "";
                        if (labelText.includes(selectedLocation)) {
                            checkbox.checked = true;
                            locationMatched = true;
                        } else {
                            checkbox.checked = false;
                        }
                    });

                    if (locationMatched) {
                        updateFilterURL(selectedLocation);
                        applyShopifyFilter();
                    } else {
                        console.warn("No matching checkbox found for:", selectedLocation);
                    }
                }
            });
        }

        function updateFilterURL(location) {
            let currentURL = new URL(window.location.href);
            currentURL.searchParams.set('filter.p.tag', location);
            currentURL.searchParams.set('filter.v.m.multilocation_app.inventory_location', location);
            window.history.pushState({}, '', currentURL.toString());
            applyShopifyFilter();
        }

        function applyShopifyFilter() {
            if (window.Shopify && window.Shopify.theme && window.Shopify.theme.handleFilters) {
                window.Shopify.theme.handleFilters();
            } else {
                location.reload();
            }
        }
        const observer = new MutationObserver(() => {
            let locationDropdown = document.getElementById('locationNamesDropDownselect');
            if (locationDropdown) {
                observer.disconnect();
                if (enabledSmartCollectionFilter === true || enabledSmartCollectionFilter === 'true') {
                    attachDropdownListener(locationDropdown);
                }
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });

        document.querySelectorAll('variant-radios').forEach(variantRadio => {
            const variantDataScript = variantRadio.querySelector('script[type="application/json"]');
            if (!variantDataScript) return;

            const variantData = JSON.parse(variantDataScript.textContent);
            const radioInputs = variantRadio.querySelectorAll('input[type="radio"]');

            radioInputs.forEach(input => {
                input.addEventListener('change', () => {
                    const selectedOptionValue = input.value;
                    const matchingVariant = variantData.find(variant => variant.title === selectedOptionValue);

                    if (!matchingVariant) {
                        console.warn("No matching variant found for selected option:", selectedOptionValue);
                        return;
                    }

                    const selectedVariantId = matchingVariant.id;
                    const productId = variantRadio.getAttribute('data-product');

                    const card = document.querySelector(`.multilocation_product-card[data-product-id="${productId}"]`);

                    if (!card) {
                        console.warn(`No product card found for product ID: ${productId}`);
                        return;
                    }

                    const variantWrapper = card.querySelector('.multi_variant_id');
                    if (variantWrapper) {
                        variantWrapper.setAttribute('data-variant-id', selectedVariantId);
                        updateInventoryForCard(card, selectedVariantId);
                    }
                });
            });
        });

        function updateInventoryForCard(card, variantId) {
            const selectedLocationId = localStorage.getItem("selected_location");
            const inventoryStatus = card.querySelector('.multiloc_inventory-status');
            const inventoryContainer = card.querySelector('.multiloc_inventory-container');

            if (!variantId || !window.inventoryData || !window.inventoryData.inventoryMap[variantId]) {
                inventoryStatus.textContent = "No data for selected variant";
                inventoryStatus.style.color = "gray";
                return;
            }

            const variantData = window.inventoryData.inventoryMap[variantId];
            inventoryContainer.innerHTML = '';

            if (!variantData.inventoryLevels || variantData.inventoryLevels.length === 0) {
                inventoryStatus.textContent = "No stock data available";
                inventoryStatus.style.color = "gray";
                return;
            }

            const selectedLocationInventory = variantData.inventoryLevels.filter(
                level => level.location_id === selectedLocationId
            );


            const allLocationsInventory = variantData.inventoryLevels.filter(
                level => level.available_quantity > 0
            );
            if (allLocationsInventory.length > 0) {
                inventoryStatus.textContent = "✔ Available at other locations";
                inventoryStatus.style.color = "orange";
                return;
            }

            if (selectedLocationInventory.length === 0) {
                inventoryStatus.textContent = "Not available at selected location";
                inventoryStatus.style.color = "gray";
                return;
            }

            let stockAvailable = false;
            selectedLocationInventory.forEach(level => {
                const { location_name, available_quantity } = level;
                const stockLine = document.createElement('div');
                stockLine.textContent = `${location_name}: ${available_quantity > 0 ? "In Stock" : "Out of Stock"} (${available_quantity})`;
                inventoryContainer.appendChild(stockLine);
                if (available_quantity > 0) stockAvailable = true;
            });

            inventoryStatus.textContent = stockAvailable ? "✔ Available" : "Out of Stock";
            inventoryStatus.style.color = stockAvailable ? "green" : "red";
        }

        async function updateCollectionInventory() {
            const selectedLocationId = localStorage.getItem("selected_location");
            const productCards = document.querySelectorAll('.multilocation_product-card[data-product-id]');
            const productId = Array.from(productCards)
                .map(card => card.getAttribute('data-product-id'))
                .filter(Boolean)
                .join(",");

            if (!productId) {
                // console.error("No product ID found.");
                return;
            }

            try {
                const response = await fetch(`https://multilocation.techspawn.net/api/get-collection-product-inventory?shopdomain=${encodeURIComponent(shopdomain)}&productId=${productId}`);

                if (!response.ok) {
                    console.error(`Failed to fetch inventory data. Status: ${response.status}`);
                    return;
                }

                const data = await response.json();

                if (!data || typeof data !== 'object') {
                    console.error("Invalid data structure received from the API.");
                    return;
                }

                window.inventoryData = data;

                productCards.forEach(card => {
                    const variantWrapper = card.querySelector('.multi_variant_id');
                    const variantId = variantWrapper?.getAttribute('data-variant-id');

                    if (!variantId || !data.inventoryMap[variantId]) {
                        console.warn(`No inventory data for variantId: ${variantId}`);
                        return;
                    }

                    updateInventoryForCard(card, variantId);
                });

            } catch (error) {
                console.error("Error fetching inventory data:", error);
            }
        }


        await updateCollectionInventory();

        document.addEventListener("updateCollectionInventory", function () {
            const selectedLocationId = localStorage.getItem("selected_location");
            if (selectedLocationId) {
                updateCollectionInventory();
                if (enabledSmartCollectionFilter === true || enabledSmartCollectionFilter === 'true') {
                    // const locationshowonheader = document.createElement("div");
                    // locationshowonheader.classList.add("location-popup-header");
                    // locationshowonheader.id = "location-popup-header-id";

                    const locationshowonheader = document.getElementById("location-popup-header-id");
                    const locationname = locationshowonheader.textContent;
                    console.log(locationname);
                    updateFilterURL(locationname);
                    applyShopifyFilter();
                }
            }
        });

    }
});